import { Box } from "@chakra-ui/react";

import { Statistic } from "@/api";
import { BasicInfoList } from "@/components/basic-info-list";

const labelMap: Record<string, string> = {
  sum: "Som",
  count: "Aantal",
  min: "Minimum",
  max: "Maximum",
  mean: "Gemiddelde",
  median: "Mediaan",
};
export const ReportStatistics = ({
  statistics,
}: {
  statistics: Statistic[] | null | undefined;
}) => {
  if (!statistics) return null;
  return (
    <Box>
      <BasicInfoList
        gap={1}
        infos={statistics.map(({ statistic, value }) => ({
          label: statistic in labelMap ? labelMap[statistic] : statistic,
          value,
        }))}
      />
    </Box>
  );
};
